module.exports = __webpack_public_path__ + "static/img/sports.91fc57b8.png";